import {
  ADD_AWARD_SHORTLISTED_DETAILS_FAILURE,
  ADD_AWARD_SHORTLISTED_DETAILS_REQUEST,
  ADD_AWARD_SHORTLISTED_DETAILS_RESET,
  ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const addAwardShortlistedDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AWARD_SHORTLISTED_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case ADD_AWARD_SHORTLISTED_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case ADD_AWARD_SHORTLISTED_DETAILS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default addAwardShortlistedDetailsReducer
